import React, { useState, useEffect } from 'react'
import MobileHeader from '../components/Headers/MobileHeader';
import NonMobileHeader from '../components/Headers/NonMobileHeader';

export default function Header({ logout, usrName, locations, reload, usrRole }) {

    return (
        <NonMobileHeader logout={logout} usrName={usrName} locations={locations} reload={reload} usrRole={usrRole} />
    )
}